import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Magnify: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <circle
      cx={19.988}
      cy={20.293}
      r={13.024}
      style={{
        fill: '#fff',
      }}
    />
    <path
      d="M33.11 28.323a15.293 15.293 0 0 0 2.154-10.086c-.979-6.953-6.56-12.437-13.416-13.318-9.988-1.175-18.41 7.247-17.235 17.235.881 6.855 6.365 12.437 13.22 13.318 3.722.49 7.247-.392 10.087-2.154l9.4 8.813c2.253 2.252 6.17.686 6.17-2.546 0-.98-.391-1.86-1.077-2.546l-9.303-8.716zM19.988 33.22c-7.149 0-13.025-5.876-13.025-13.024S12.741 7.268 19.988 7.268s13.024 5.876 13.024 13.024S27.136 33.22 19.988 33.22z"
      style={{
        fill: '#002677',
      }}
    />
    <path
      d="M10.668 20.194a1.25 1.25 0 0 1-1.242-1.401c.55-4.503 4.05-8.218 8.513-9.035a1.25 1.25 0 0 1 .45 2.459c-3.398.622-6.063 3.45-6.481 6.878a1.25 1.25 0 0 1-1.24 1.099z"
      style={{
        fill: '#ff612b',
      }}
    />
  </Box>
)
export default Magnify
